namespace GeniuzPOS.ReportMasterData {
    export class Report_1401Columns {
        static columnsKey = 'ReportMasterData.Report_1401';
    }
}
